import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import {
  BulbIcon,
  ColumnsChartIcon,
  NodesIcon,
  PersonAndBoardIcon,
  PieChartIcon,
  ProjectionIcon,
  QuestionIcon,
  SearchIcon,
  TargetIcon,
  UserIcon,
} from 'assets/icons/OnePageSvgs';

import { IconMap, ISectionContainerProps as IProps, ONE_PAGE_SECTION_VARIANTS } from './types';

import styles from './LargeCard.module.scss';

export const icons: IconMap = {
  description: <SearchIcon />,
  goals: <TargetIcon />,
  problemDefinition: <QuestionIcon />,
  problemSolving: <BulbIcon />,
  targetMarket: <PieChartIcon />,
  marketDynamics: <ColumnsChartIcon />,
  mainCompetitors: <PersonAndBoardIcon />,
  targetAudience: <UserIcon />,
  businessModel: <NodesIcon />,
  salesStrategy: <ProjectionIcon />,
};

export const LargeCard: FC<IProps> = ({
  title,
  content,
  icon,
  className = '',
  variant = ONE_PAGE_SECTION_VARIANTS.PRIMARY,
  customStyles,
}) => {
  return (
    <Box
      sx={customStyles}
      className={clsx(styles.sectionWrapper, className, {
        [styles.lime]: variant === ONE_PAGE_SECTION_VARIANTS.SECONDARY,
        [styles.transparent]: variant === ONE_PAGE_SECTION_VARIANTS.TRANSPARENT,
      })}
    >
      <Box className={styles.iconContainer}>{icon}</Box>
      <Typography variant="body1" className={styles.title}>
        {title}
      </Typography>
      <Typography variant="body1" className={styles.content}>{content}</Typography>
    </Box>
  );
};
